import {
    GET_PRODUCTCLASS_ERROR,
    GET_PRODUCTCLASS_REQUEST,
    GET_PRODUCTCLASS_SUCCESS,
    ADD_PRODUCTCLASS_ERROR,
    ADD_PRODUCTCLASS_REQUEST,
    ADD_PRODUCTCLASS_SUCCESS,
    DELETE_PRODUCTCLASS_REQUEST,
    DELETE_PRODUCTCLASS_SUCCESS,
    DELETE_PRODUCTCLASS_ERROR,
    UPDATE_PRODUCTCLASS_ERROR,
    UPDATE_PRODUCTCLASS_REQUEST,
    UPDATE_PRODUCTCLASS_SUCCESS,
} from "./types";

import { BASEURL } from "../../constant/config.js";

const axios = require("axios");

export const getProductClass = (token, menu_id) => (dispatch) => {
    dispatch({ type: GET_PRODUCTCLASS_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/product_class`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { menu_id }
    })
        .then((response) => {
            return dispatch({ type: GET_PRODUCTCLASS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_PRODUCTCLASS_ERROR,
                payload: error.response,
            });
        });
};

export const addProductClass = (token, data, menu_id) => (dispatch) => {
    dispatch({ type: ADD_PRODUCTCLASS_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/product_class`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { product_class_name: data.productClassName, is_active: data.check, menu_id },
    })
        .then((response) => {

            return dispatch({ type: ADD_PRODUCTCLASS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_PRODUCTCLASS_ERROR,
                payload: error.response,
            });
        });
};

export const updateProductClass = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_PRODUCTCLASS_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/product_class/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { product_class_name: data.productClassName, is_active: data.check },
    })
        .then((response) => {

            return dispatch({ type: UPDATE_PRODUCTCLASS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_PRODUCTCLASS_ERROR,
                payload: error.response,
            });
        });
};

export const deleteProductClass = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_PRODUCTCLASS_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/product_class/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {

            return dispatch({ type: DELETE_PRODUCTCLASS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_PRODUCTCLASS_ERROR,
                payload: error.response,
            });
        });
};
